export default __webpack_public_path__ + "static/media/request-uncompleted.25504e10.svg";